import { OrgRoles } from '@/api';
import { Button } from '@/components/ui/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { ChevronDownIcon } from 'lucide-react';

type orgRolesDropdownItem = {
  value: OrgRoles;
  description: string;
};
const orgRoles: orgRolesDropdownItem[] = [
  { value: 'Member', description: 'Read only access to Organization' },
  { value: 'Admin', description: 'Organization Management' },
  { value: 'Owner', description: 'Organization Management, Billing' },
];

interface Props {
  value: OrgRoles;
  onChange: (value: OrgRoles) => void;
  disabled?: boolean;
}

function OrgRoleSelect({ value, onChange, disabled }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={o => setIsOpen(o)}>
      <PopoverTrigger asChild disabled={disabled}>
        <Button variant="outline" className="ml-auto">
          {value || 'Member'}
          <ChevronDownIcon className="ml-2 h-4 w-4 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="end">
        <Command>
          <CommandInput placeholder="Select new role..." />
          <CommandList>
            <CommandEmpty>No roles found.</CommandEmpty>
            <CommandGroup className="p-1.5">
              {orgRoles.map(r => (
                <CommandItem
                  key={r.value}
                  onSelect={() => {
                    onChange(r.value);
                    setIsOpen(false);
                  }}
                  className="teamaspace-y-1 flex flex-col items-start px-4 py-2"
                >
                  <p>{r.value}</p>
                  <p className="text-sm text-muted-foreground">
                    {r.description}
                  </p>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default OrgRoleSelect;
